import React from "react";

/**
 * MetricTiles - a responsive row of icon metric cards.
 *
 * @param {Object[]} items - [{ label, value, icon, accent }]
 *   icon: one of the keys in ICONS below; accent: brand | amber | red | green
 */
const ICONS = {
  clients: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  risk: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l9 16H3l9-16z" /><path d="M12 10v4" /><path d="M12 17h.01" />
    </svg>
  ),
  active: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><path d="M22 4L12 14.01l-3-3" />
    </svg>
  ),
  scans: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" />
    </svg>
  ),
  progress: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
    </svg>
  ),
  completed: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  flagged: (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 21V4h13l-2 4 2 4H4" />
    </svg>
  ),
};

const CHIP = {
  brand: "bg-brand-50 text-brand-600 dark:bg-brand-500/10",
  amber: "bg-amber-50 text-amber-600 dark:bg-amber-500/10",
  red: "bg-red-50 text-red-600 dark:bg-red-500/10",
  green: "bg-green-50 text-green-600 dark:bg-green-500/10",
};

export default function MetricTiles({ items = [] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {items.map((it) => (
        <div
          key={it.label}
          className="rounded-xl border border-border bg-card shadow-card p-5 flex items-center gap-4"
        >
          <span className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${CHIP[it.accent] || CHIP.brand}`}>
            {ICONS[it.icon] || ICONS.scans}
          </span>
          <div>
            <div className="text-2xl font-semibold text-foreground leading-tight">{it.value ?? 0}</div>
            <div className="text-sm text-muted-foreground">{it.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
